import Header from '../../components/Header'
import Footer from '../../components/Footer'
import * as S from '../../styles/page-profile'
import ErrorNotFound from '../../components/ErrorNotFound'
import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { getLocalStorageLog } from '../../utils/traceLogAcessos'

function Erro404() {
  const location = useLocation()
  
  useEffect(() => {  
    getLocalStorageLog(location.pathname)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Header></Header>
      <S.Profile className="perfil">
        <S.PageContent className="page-content">
          <S.Wrapper className="wrapper">
            <ErrorNotFound />
          </S.Wrapper>
        </S.PageContent>
      </S.Profile>
      <Footer />
    </>
  )
}

export default Erro404
